function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable jsx-a11y/mouse-events-have-key-events, no-return-assign */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { arc, pie } from 'd3-shape';
import cx from 'classnames';
import noop from "../utils/noop";

var DoughnutChart =
/*#__PURE__*/
function (_Component) {
  _inherits(DoughnutChart, _Component);

  function DoughnutChart() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DoughnutChart);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DoughnutChart)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      height: 375,
      size: 20,
      margin: 75,
      hovered: null
    });

    _defineProperty(_assertThisInitialized(_this), "setSize", function () {
      if (_this._panel) {
        var clientWidth = _this._panel.clientWidth;

        _this.setState({
          width: clientWidth
        });
      }
    });

    return _this;
  }

  _createClass(DoughnutChart, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var data = this.props.data;
      this.updateVisibleData(data);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setSize();
      window.addEventListener('resize', this.setSize);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var data = _ref.data;
      this.updateVisibleData(data);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setSize);
    }
  }, {
    key: "getIncreasedOuterArcFn",
    value: function getIncreasedOuterArcFn() {
      var size = this.state.size;
      return arc().innerRadius(this.radius() + size).outerRadius(this.radius() + size);
    }
  }, {
    key: "getIncreasedArcFn",
    value: function getIncreasedArcFn() {
      var size = this.state.size;
      return arc().innerRadius(this.radius() - size).outerRadius(this.radius() + size);
    }
  }, {
    key: "getOuterArcFn",
    value: function getOuterArcFn() {
      return arc().innerRadius(this.radius()).outerRadius(this.radius());
    }
  }, {
    key: "getArcFn",
    value: function getArcFn() {
      var size = this.state.size;
      return arc().innerRadius(this.radius() - size).outerRadius(this.radius());
    }
  }, {
    key: "radius",
    value: function radius() {
      var _this$state = this.state,
          margin = _this$state.margin,
          width = _this$state.width,
          height = _this$state.height;
      return Math.min(width, height) / 2 - margin;
    }
  }, {
    key: "updateVisibleData",
    value: function updateVisibleData(d) {
      var valueKey = this.props.valueKey;

      if (d) {
        var data = DoughnutChart.makingVisibility(DoughnutChart.rearrangeData(DoughnutChart.calculatePercentage(d, valueKey), valueKey), valueKey);
        this.setState({
          data: data
        });
      }
    }
  }, {
    key: "isRecordHovered",
    value: function isRecordHovered(record) {
      var hovered = this.state.hovered;
      if (hovered) return hovered.index === record.index;
      return false;
    }
  }, {
    key: "increaseArc",
    value: function increaseArc(record) {
      this.setState({
        hovered: record
      });
      this.props.onHover(record);
    }
  }, {
    key: "decreaseArc",
    value: function decreaseArc() {
      this.setState({
        hovered: null
      });
      this.props.onHover(null);
    }
    /**
     * Moves lines for making some space between them
     */

  }, {
    key: "movePolylines",
    value: function movePolylines(polylines) {
      var result = _toConsumableArray(polylines);

      var minimalOffset = this.radius() / 4;

      for (var i = 1; i < result.length; ++i) {
        var offset = Math.abs(result[i].y2 - result[i - 1].y2);

        if (offset < minimalOffset) {
          var diff = Math.abs(offset - minimalOffset);
          result[i] = DoughnutChart.moveLineUp(result[i], diff / 2);
          result[i - 1] = DoughnutChart.moveLineDown(result[i - 1], diff / 2);
        }
      }

      return result;
    }
  }, {
    key: "renderArc",
    value: function renderArc() {
      var _this2 = this;

      var data = this.state.data;
      var increasedArcFn = this.getIncreasedArcFn();
      var arcFn = this.getArcFn();
      var pieFn = DoughnutChart.getPieFn();
      var pieData = pieFn(data);
      return pieData.map(function (record, i) {
        var isHovered = _this2.isRecordHovered(record);

        var style = {};
        if (isHovered) style.filter = 'url(#dropShadow)';
        return React.createElement("path", {
          className: "Doughnut-chart-segment",
          key: i,
          fill: record.data.color,
          d: isHovered ? increasedArcFn(record) : arcFn(record),
          style: style,
          onMouseOver: function onMouseOver() {
            return _this2.increaseArc(record);
          },
          onMouseOut: function onMouseOut() {
            return _this2.decreaseArc(record);
          }
        });
      });
    }
  }, {
    key: "renderLines",
    value: function renderLines() {
      var _this3 = this;

      var _this$props = this.props,
          labelKey = _this$props.labelKey,
          subLabelKey = _this$props.subLabelKey,
          renderLabel = _this$props.renderLabel;
      var _this$state2 = this.state,
          width = _this$state2.width,
          data = _this$state2.data;
      var labelOffset = this.radius() / 15;
      var increasedOuterArcFn = this.getIncreasedOuterArcFn();
      var arcFn = this.getOuterArcFn();
      var pieFn = DoughnutChart.getPieFn();
      var pieData = pieFn(data);
      var lines = pieData.map(function (record) {
        var _arcFn$centroid = arcFn.centroid(record),
            _arcFn$centroid2 = _slicedToArray(_arcFn$centroid, 2),
            x = _arcFn$centroid2[0],
            y = _arcFn$centroid2[1];

        var x1 = x < 0 ? -width / 2 : x;
        var x2 = x < 0 ? x : width / 2;
        var y1 = y;
        var y2 = y;
        return {
          x1: x1,
          x2: x2,
          y1: y1,
          y2: y2,
          record: record
        };
      });
      var polylines = lines.map(function (_ref2) {
        var x1 = _ref2.x1,
            x2 = _ref2.x2,
            y1 = _ref2.y1,
            y2 = _ref2.y2,
            record = _ref2.record;

        var _increasedOuterArcFn$ = increasedOuterArcFn.centroid(record),
            _increasedOuterArcFn$2 = _slicedToArray(_increasedOuterArcFn$, 2),
            x = _increasedOuterArcFn$2[0],
            y = _increasedOuterArcFn$2[1];

        var isOnLeftSide = x < 0;
        return {
          x1: x1,
          y1: isOnLeftSide ? y : y1,
          x2: x,
          y2: y,
          x3: x2,
          y3: isOnLeftSide ? y2 : y,
          record: record
        };
      });
      return this.movePolylines(polylines).map(function (polyline, i) {
        var x1 = polyline.x1,
            y1 = polyline.y1,
            x2 = polyline.x2,
            y2 = polyline.y2,
            x3 = polyline.x3,
            y3 = polyline.y3,
            record = polyline.record;
        var amountClasses = cx('Doughnut-chart-tx-amount', {
          'Doughnut-chart-tx-amount-strong': _this3.isRecordHovered(record)
        });
        var _record$data = record.data,
            label = _record$data[labelKey],
            subLabel = _record$data[subLabelKey];
        return React.createElement("g", {
          key: i
        }, React.createElement("polyline", {
          className: "Doughnut-chart-tx-line",
          points: "".concat(x1, ",").concat(y1, " ").concat(x2, ",").concat(y2, " ").concat(x3, ",").concat(y3),
          strokeWidth: _this3.isRecordHovered(record) ? 2 : 1
        }), renderLabel ? renderLabel(polyline, i) : React.createElement("text", {
          className: amountClasses,
          dy: "0.1em",
          transform: "translate(".concat(x1 < 0 ? x1 : x3, ",").concat(y2 - labelOffset, ")"),
          style: {
            textAnchor: x1 < 0 ? 'start' : 'end'
          }
        }, label), subLabel ? React.createElement("text", {
          className: "Doughnut-chart-tx-type",
          dy: "0.5em",
          transform: "translate(".concat(x1 < 0 ? x1 : x3, ",").concat(y2 + labelOffset, ")"),
          style: {
            textAnchor: x1 < 0 ? 'start' : 'end'
          }
        }, subLabel) : null, React.createElement("rect", {
          fillOpacity: "0",
          x: x1 - 10,
          y: Math.min(y1, y2, y3) - 20,
          width: x3 - x1 + 20,
          height: Math.max(y1, y2, y3) - Math.min(y1, y2, y3) + 40,
          onMouseOver: function onMouseOver() {
            return _this3.increaseArc(record);
          },
          onMouseOut: function onMouseOut() {
            return _this3.decreaseArc(record);
          }
        }));
      });
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var title = this.props.title;
      return React.createElement("g", null, React.createElement("text", {
        className: "Doughnut-chart-title"
      }, title));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state3 = this.state,
          className = _this$state3.className,
          width = _this$state3.width,
          height = _this$state3.height;
      return React.createElement("div", {
        className: cx('Doughnut-chart', className),
        ref: function ref(c) {
          return _this4._panel = c;
        }
      }, React.createElement("svg", {
        width: width || height,
        height: height
      }, React.createElement("defs", null, React.createElement("filter", {
        id: "dropShadow",
        x: "0",
        y: "0",
        width: "300%",
        height: "300%"
      }, React.createElement("feGaussianBlur", {
        in: "SourceAlpha",
        result: "blur-out",
        stdDeviation: "2"
      }), React.createElement("feOffset", {
        in: "blur-out",
        result: "the-shadow",
        dx: "2",
        dy: "1"
      }), React.createElement("feColorMatrix", {
        in: "the-shadow",
        result: "color-out",
        type: "matrix",
        values: "0 0 0 0   0 0 0 0 0   0 0 0 0 0   0 0 0 0 .25 0"
      }), React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "color-out",
        mode: "normal"
      }))), width ? React.createElement("g", {
        transform: "translate(".concat(width / 2, ",").concat(height / 2, ")")
      }, this.renderLines(), this.renderArc(), this.renderTitle()) : null));
    }
  }], [{
    key: "makingVisibility",

    /**
     * Make small values visible (till 2 degrees) on chart
     */
    value: function makingVisibility(data, keyName) {
      var minPart = 0.005; // ~2/360

      var result = _toConsumableArray(data);

      var sumValues = result.reduce(function (acc, record) {
        return acc + record[keyName];
      }, 0);
      return result.map(function (record) {
        var part = record[keyName] / sumValues;
        return _objectSpread({}, record, {
          visibleValue: record[keyName] * (part < minPart ? minPart / part : 1)
        });
      });
    }
  }, {
    key: "calculatePercentage",
    value: function calculatePercentage(data, keyName) {
      var result = _toConsumableArray(data);

      var sumValues = result.reduce(function (acc, record) {
        return acc + record[keyName];
      }, 0);
      return result.map(function (record) {
        var percentage = record[keyName] * 100 / sumValues;
        if (percentage > 1) percentage = Math.round(percentage);else percentage = percentage.toFixed(1);
        return _objectSpread({}, record, {
          percentage: percentage
        });
      });
    }
    /**
     * Rearranges data for less labels intersection + filter zero values
     */

  }, {
    key: "rearrangeData",
    value: function rearrangeData(data, keyName) {
      var array = _toConsumableArray(data);

      array = array.sort(function (a, b) {
        return a[keyName] - b[keyName];
      }).filter(function (record) {
        return record[keyName] !== 0;
      });
      var result = [];

      while (array.length) {
        result.push(array[array.length - 1]);
        array.pop();

        if (array.length) {
          result.push(array[0]);
          array.shift();
        }
      }

      return result;
    }
  }, {
    key: "getPieFn",
    value: function getPieFn() {
      return pie().value(function (d) {
        return d.visibleValue;
      }).sort(null);
    }
  }, {
    key: "moveLine",
    value: function moveLine(line, dy) {
      var y1 = line.y1,
          y2 = line.y2,
          y3 = line.y3;
      var isOnLeftSide = line.x1 < 0;
      return _objectSpread({}, line, {
        y1: isOnLeftSide ? y1 + dy : y1,
        y2: y2 + dy,
        y3: isOnLeftSide ? y3 : y3 + dy
      });
    }
  }, {
    key: "moveLineUp",
    value: function moveLineUp(line, dy) {
      return DoughnutChart.moveLine(line, line.y1 < 0 ? -dy : Number(dy));
    }
  }, {
    key: "moveLineDown",
    value: function moveLineDown(line, dy) {
      return DoughnutChart.moveLine(line, line.y1 < 0 ? Number(dy) : -dy);
    }
  }]);

  return DoughnutChart;
}(Component);

_defineProperty(DoughnutChart, "propTypes", {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  valueKey: PropTypes.string.isRequired,
  labelKey: PropTypes.string,
  subLabelKey: PropTypes.string,
  renderLabel: PropTypes.func,
  onHover: PropTypes.func
});

_defineProperty(DoughnutChart, "defaultProps", {
  onHover: noop
});

export default DoughnutChart;